import { gql } from '@apollo/client'
import { AddressFragment } from '../fragments/address.fragments'

export const UserProfileInfoFragment = gql`
    fragment userProfileInfoFragment on professionalDiscipline {
        prefix
        firstName
        lastName
        suffix
        phone
        address {
            ...addressFragment
        }
        professionalDiscipline
        professionalRole
        title
        imageUrl
    }
    ${AddressFragment}
`

export const UserProfileQuery = gql`
    query user($firmId: String, $userId: String) {
        user(firmId: $firmId, id: $userId) {
            id
            email
            role
            status
            isBestPracticeGroupEnabled
            isDesignatedAccountAdminUser
            profileInfo {
                ...userProfileInfoFragment
            }
            showGettingStartedAgain
        }
    }
    ${UserProfileInfoFragment}
`
